import { accountIdFormat } from "@redotech/redo-account-id";
import * as z from "zod";

export const getMerchantGradeOptions = {
  name: "getMerchantGradeOptions" as const,
  input: z.object({ merchantAccountId: accountIdFormat.schema }),
  output: z.object({ grades: z.array(z.string()) }),
};
